import { ReactNode } from "react";
import "./CareContentWrap.css";

interface CareContentWrapProps {
  children: ReactNode;
}

export const CareContentWrap = ({ children }: CareContentWrapProps) => {
  return <section className="care-content-wrap">{children}</section>;
};
